<template>
  <div>
    <div
      v-if="!currentPaymentMethod.paymentMethodId"
      class="_mbxs"
      container>
      <div  class="announcements" role="alert">
        <div class="announcement -notice">
          <div>
            <div class="title _mbxs">{{ no_payment_method_title }}</div>
            <div v-html="no_payment_method_content_html"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="currentPaymentMethod.paymentMethodId && !autoPayEnabled" class="_mbxs" container>
      <div  class="announcements" role="alert">
        <div class="announcement -notice">
          <div>
            <div class="title _mbxs"> {{ disabled_recurring_payment_title }}</div>
            <div v-html="disabled_recurring_payment_content_html"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import billing from '@mixins/billing'
  import paymentVerbiage from '@mixins/paymentVerbiage'
  export default {
    mixins: [billing, paymentVerbiage]
  }
</script>
